import { useParams, useSearchParams, useLocation } from 'react-router-dom';

interface AllParams {
  pathParams: Record<string, string | undefined>;
  queryParams: Record<string, string>;
  hash: string;
  pathname: string;
  fullPath: string;
  stringifyObject: (obj: Record<string, any>, withoutEncode?: boolean) => string;
}

export default function useHandleParams(): AllParams {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const queryParams: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    queryParams[key] = value;
  });

  // 把对象设置成 queryParams
  const stringifyObject = (obj: Record<string, any> = {}, withoutEncode: boolean = false) => {
    return Object.keys(obj)
      .map(key => `${key}=${withoutEncode ? obj[key] : encodeURIComponent(obj[key])}`)
      .join('&');
  }


  return {
    pathParams: params,
    queryParams,
    hash: location.hash,
    pathname: location.pathname,
    fullPath: location.pathname + location.search + location.hash,
    stringifyObject
  };
};